export default __webpack_public_path__ + "static/media/serie-3.4e445364.png";